import { Box } from '@mui/material';
import { FullPageWrapperForLoader, LoaderContainer } from 'components/authentication/style';
import EnaraLoader from 'components/elements/loaders/enara-loader/EnaraLoader';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { completeHubSignIn, HUB_CALLBACK_PATH, HubSignInError } from 'services/hub-auth-service';
import { takeStashedCallbackSearch } from 'services/hub-callback';
import { hasUsableSession, LoginLocationState } from 'services/session';

const visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
} as const;

/**
 * Where the Hub sends the browser back to. Completes the sign-in, then replaces
 * itself with the app or, on failure, the sign-in page with the reason.
 */
const AuthCallback = () => {
  const history = useHistory<LoginLocationState>();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) {
      return;
    }
    started.current = true;

    // Stashed and stripped at startup, before Sentry started; read from the URL
    // otherwise. Then drop them from the URL and from history (replace updates
    // the router's location as well).
    const search = takeStashedCallbackSearch() ?? window.location.search;
    history.replace(HUB_CALLBACK_PATH);

    completeHubSignIn(search)
      .then((result) => {
        const signedIn = result === 'signed-in' || hasUsableSession();
        history.replace(signedIn ? '/' : '/login');
      })
      .catch((error) => {
        history.replace({
          pathname: '/login',
          state: {
            hubSignInError: error instanceof HubSignInError ? error.code : 'unavailable',
          },
        });
      });
  }, []);

  return (
    <FullPageWrapperForLoader role='status'>
      <LoaderContainer>
        <EnaraLoader />
      </LoaderContainer>
      <Box component='span' sx={visuallyHidden}>
        Signing you in…
      </Box>
    </FullPageWrapperForLoader>
  );
};

export default AuthCallback;
